import { ReportDto } from "../services/api/model/report-dto";
import { SurveyResponseDto } from "../services/api/model/survey-response-dto";

export const isReport = (report: ReportDto | SurveyResponseDto): report is ReportDto => !!(report as ReportDto).storeId;
